import ImportInstallationsContent from "./../modules/installation/pages/ImportInstallations/fr";
import ImportCompressorsContent from "../modules/installation/pages/ImportCompressors/fr";
import ImportSitesContent from "./../modules/company/pages/ImportSites/fr";
import ImportClientsContent from "./../modules/company/pages/ImportClients/fr";
import PrivacyPolicy from "../modules/common/pages/PrivacyPolicy/fr";
import CGU from "../modules/common/pages/CGU/fr";

export default {
  ImportInstallationsContent,
  ImportCompressorsContent,
  ImportSitesContent,
  ImportClientsContent,
  PrivacyPolicy,
  CGU,
};
